<template>
  <div class="m-proudct-page-content" :class="'type_' + show">
    <sticky-bar :anchors="anchors"></sticky-bar>

    <div class="product-show">
      <!--行模板一-->
      <div class="panel-main row-item"
           v-for="(item, idx) in products"
           :key="idx">
        <!--模板一-->
       <!-- <div class="public-layout-table2" v-if="idx%2 === 0">
          <div class="panel-item">
            <div class="content-wraper">
              <dl class="product-info-sheet">
                <dt>{{item.name}}</dt>
                <dd>{{item.abstrct}}</dd>
                <dd v-if="item.applys">
                  <h3>应用场合：</h3>
                  {{item.applys}}
                </dd>
              </dl>
            </div>
          </div>
          <div class="panel-item prod-show">
            <div class="content-wraper" :style="{backgroundImage: 'url('+item.cover+')', 'backgroundPosition': item.position, backgroundSize: item.bgSize, height: item.height}">
            </div>
          </div>
        </div>-->
        <!--模板二-->
        <div class="public-layout-table2">
          <dl class="product-info-sheet">
            <dt>{{item.name}}</dt>
            <dd class="panel-item prod-show">
              <div class="content-wraper" :style="{backgroundImage: 'url('+item.cover+')'}">
              </div>
            </dd>
            <dd>{{item.abstrct}}</dd>
            <dd v-if="item.applys">
              <h3>应用场合：</h3>
              {{item.applys}}
            </dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import HeaderBar from '../components/HeaderBar'
  import FooterBar from '../components/FooterBar'
  import Banner from '../components/Banner'
  import StickyBar from '../components/stickyBar.vue'

  export default {
    data () {
      return {
        anchors: [{
          title: '终端产品',
          name: 'mProduction',
          params: {type: 'terminal'},
          icon: require('../../static/images/icon-terminal.png')
        }, {
          title: '软件产品',
          name: 'mProduction',
          params: {type: 'software'},
          icon: require('../../static/images/icon-software.png')
        }],
        data: {
          terminal: [{
            name: '资格认证移动终端TI',
            abstrct: '指纹+人脸双生物识别技术，体积小巧，方便手持，实现资格认证的移动化办理。在基层行政单元实现上述功能，提高人社业务覆盖范围，防范社保基金冒领风险，提高业务经办效率，适用于待遇资格核查上门服务、移动生物识别身份认证服务。',
            cover: require('../../static/images/products/T1.png')
          }, {
            name: '医疗保险稽查移动终端T2',
            abstrct: '通过社保卡和生物识别特征相结合实人实名认证方式，实现医疗保险稽查的移动资格认证工作。采取定期、不定期、随机抽查等线上+线下结合的稽查形式，有效防范定点医疗机构挂床住院、冒名就医现象，确保医疗保险稽查政策执行到位，保障基金安全。',
            cover: require('../../static/images/products/T2.png')
          }, {
            name: '人社基层业务经办智能终端T3',
            abstrct: '全新便携式多功能智能终端，面向基层业务经办工作人员，解决无现金缴费、资格认证、社保查询等基层经办业务。降低基层业务的经办风险，提高业务的经办效率，助力人社业务向基层渗透。实现数据多跑路，百姓少跑腿，提高人社的公共服务和群众的满意度。',
            cover: require('../../static/images/products/T3.png')
          }, {
            name: '桌面式社保自助服务一体机',
            abstrct: '桌面式社保自助服务一体机是一款集人脸识别、指纹识别、指静脉识别、二代证实名认证、社保卡实名认证于一体的嵌入式终端设备，可独立完成人脸识别、指纹识别、指静脉识别，有效提高基层综合业务经办效率，广泛应用于网点居保养老多重身份认证工作。',
            cover: require('../../static/images/products/YTJ.png')
          }, {
            name: '桌立式社保自助服务一体机面设备',
            abstrct: '立式社保自助服务一体机是一款集人脸、指纹、指静脉识别身份认证，社保信息查询，社保业务办理等功能于一体的立式终端设备。配备有19英寸液晶触摸屏、打印机和密码键盘等，具备脱机和联机认证能力，能有效提高基层综合业务经办能力。广泛应用于网点居保养老多重身份认证工作。',
            cover: require('../../static/images/products/LSYTJ.png')
          }, {
            name: '双摄人脸识别仪',
            abstrct: '双摄人脸识别仪采用多点光源补光技术，兼具近红外和可见光的视频采集功能，支持近红外（850mm）和可见光双目摄像头人脸图像采集。广泛应用于人社认证基层业务现场人脸的模板采集和认证。',
            cover: require('../../static/images/products/SMSXT.png')
          }, {
            name: '光学指纹采集仪',
            abstrct: '指纹识别仪是拥有高速DSP处理器，结合光学指纹传感器，具有指纹录入、图像处理、指纹比对、搜索和模板储存等功能的智能型指纹采集器，广泛应用于社保业务经办机构，街道、社区、银行、医院大厅等需要进行指纹模板采集以及指纹比对认证的场所。',
            cover: require('../../static/images/products/GXZWY.png')
          }, {
            name: '指静脉识别仪',
            abstrct: '指静脉识别仪是一款集指静脉识别模块采集和身份认证于一体的嵌入式移动终端设备，具有集成化高、上电速度快，效率高、功能低等优点。可广泛应用于社保业务经办机构，街道、社区、银行、医院机构、药店等需要进行指静脉识别数据采集与身份比对的场所。',
            cover: require('../../static/images/products/ZJMY.png')
          }, {
            name: '线索解析管理一体机 ETEK-JS-I3',
            abstrct: '开箱即用，搭配双处理器和软硬件集成的一体机化架构，极大缩短部署和价值实现时间，可充分发挥 Hadoop、Spark、NoSQL 等大数据工具的全部价值。内置自动识别异常软件，并迅速跟踪欺诈活动，保证数据可靠性。实现全面的线索采集、线索录入、线索评估、线索检索、线索执行、执行管理、执行反馈等多种功能，可选择预装适用行业相关线索收集方式和检查流程的一体化版本（目前包含医保行业、食品药品监管行业和环境保护行业等多个版本），可与其他平台进行关联和互享，实现监管和数据安全保障。',
            cover: require('../../static/images/products/etek-js.png')
          }, {
            name: '线索采集一体机ETEK-JS-I1',
            abstrct: '开箱即用，搭配高性能处理器，专门针对线索采集使用场景。自适应信访信件、邮箱、举报投诉电话、网上留言等多渠道的线索根据来源，使用文本分析和多通道语音采集技术，对线索进行数字化标准转换，能够进行信息识别及判断，进行查重、初筛，自动提取有用信息，进行分析管理和存档，实现精准查找问题线索，提高工作效率，适用全场景下的线索采集和基本管理。',
            cover: require('../../static/images/products/etek-jc.png')
          }, {
            name: '记录仪ETEK-JC-M04',
            abstrct: '体积小、重量轻，拥有红外夜视，超长续航，一次充电可实现8小时摄录的强大功能，可轻松实现现场音频采集、现场取证，能够应对监管过程中的静态、动态和紧急情况的数字化记录，搭配飞检系统，主要适用于飞行检查需要进行现场检查、监管、执法等场景。',
            cover: require('../../static/images/products/etek-jc-m04.png')
          }, {
            name: '记录仪ETEK-JC-M02',
            abstrct: '体型小巧易携带，拥有红外夜视、补光、激光定点、循环录影等多种功能，可轻松实现现场音频采集、现场取证，能够应对监管过程中的静态、动态和紧急情况的数字化记录、报警等，搭配飞检系统，主要适用于飞行检查需要进行现场检查、监管、执法等场景。',
            cover: require('../../static/images/products/etek-jc-m02.png')
          }, {
            name: '飞检智能终端 ETEK-JC-IG2',
            abstrct: '包含飞检记录仪、移动办公终端和第一视角飞检终端三个部分，体积小巧易携带，全媒体通讯、第一视角画面多方共享、冻屏辅助、多路高清传输及文件传输，现场音频采集、GPS信息采集回传，能够应对监管过程中的静态、动态和紧急情况的数字化记录、报警、视频会议、集群通话和及时消息等，搭配飞检系统可轻松实现远程现场检查，智能终端立案、现场笔录、关键信息查询、政策文档调阅、信息发布、统计报表等功能，多维度连接人、设备、和业务，远程和现场同步协同。',
            cover: require('../../static/images/products/ETEK-JC-IG2.png')
          }],
          software: [{
            name: '线索解析管理平台v1.0',
            abstrct: '实现全面的线索采集、线索录入、线索评估、线索检索、线索执行、执行管理、执行反馈等多种功能，目前包含医保行业、食品药品监管行业和环境保护行业等多个版本，可与其他平台进行关联和互享，实现监管和数据安全保障。对于多渠道多应用场景线索进行自动采集，对于检查人员、检查机构、被检查机构、人员合同、国家及地方政策文件等基础信息进行管理。对于可以进行飞行检查的任务进行下发、执行、归档、对于检查内容进行全周期的记录。与移动办公终端紧密结合，为飞行检查工作提供方便快捷的信息化服务。支持可视化指挥调度，具有远程双向视音频互通、移动前端群组交互、同步指挥调度、任务派遣、视频会议、视频传输存储、位置上图等功能。',
            cover: require('../../static/images/products/xsjxglptV1.png')
          }, {
            name: '线索采集系统v1.0',
            abstrct: '线索采集系统专门针对线索采集使用场景。结合相关智能化固件，自适应信访信件、邮箱、举报投诉电话、网上留言等多渠道的线索根据来源，使用文本分析和多通道语音采集技术，对线索进行数字化标准转换，能够进行信息识别及判断，进行查重、初筛，自动提取有用信息，进行分析管理和存档，实现精准查找问题线索，提高工作效率，适用全场景下的线索采集和信息管理。',
            cover: require('../../static/images/products/xscjxtv1.png'),
            cusStyle: 'margin-top: 130px;'
          }]
        },
        show: null
      }
    },
    computed: {
      products () {
        return this.data[this.show || 'terminal']
      }
    },
    watch: {
      '$route' (to, from) {
        this.show = to.params.type || 'bio';
      }
    },
    methods: {},
    components: {
      HeaderBar,
      FooterBar,
      Banner,
      StickyBar
    },
    created () {
      this.show = this.$route.params.type || 'terminal';
    }
  }
</script>

<style lang="scss">
  @import '../assets/style/base.scss';
  @import '../assets/style/public.scss';

  .m-proudct-page-content {
    /*文字展示信息*/
    .product-info-sheet {
      cursor: pointer;
      dt {
        font-size: .34rem;
        color: #3b3b3b;
        font-weight: bold;
        margin-bottom: .22rem;
        text-align: center;
        &:after {
          content: ' ';
          display: block;
          width: 0;
          height: 0;
          border: .08rem solid transparent;
          border-top: .08rem solid #525252;
          margin-left: auto;
          margin-right: auto;
          margin-top: .25rem;
        }
      }
      dd {
        font-size: .24rem;
        color: #3b3b3b;
        line-height: 2em;
        &.prod-show{
          .content-wraper {
            display: block;
            width: 100%;
            heigth: 0;
            padding-bottom: 45%;
            background-repeat: no-repeat;
            background-position: center center;
            -webkit-background-size: contain;
            background-size: contain;
            margin-bottom: .25rem;
          }
        }
      }
    }

    .row-item {
      @include c-wrap();
      padding: .55rem .50rem;

      .panel-item {
        float: none!important;
        width: 100% !important;
      }

      /*模板一*/
      &:nth-child(odd) {
        background: #e6e7ea;
      }

      /*模板二*/
      &:nth-child(even) {
        background: #fff;
      }
    }
    &.type_software {
      .product-info-sheet dd.prod-show .content-wraper {
        padding-bottom: 60%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/mobile/Production.vue